import { useCheckViewPoint } from "hooks/useCheckViewPoint";

export type Breakpoint = "xs" | "sm" | "md" | "lg" | "xl";

interface ViewPointProps {
  from?: Breakpoint;
  to?: Breakpoint;
  children?: React.ReactNode;
}

export const withViewPoint = (Component: React.ComponentType<any> | React.ElementType) => {
  return ({ from, to, children, ...props }: ViewPointProps) => {
    const isActive = useCheckViewPoint({ from, to });
    return isActive ? <Component {...props}>{children}</Component> : null;
  };
};
